export default [

     {
          path: '/asset-value-question',
          name: 'AssetValueQuestion',
          component: () => import("@/views/Page/AssetValueQuestion/AssetValueQuestion.vue"),
           meta: {
               title: 'Asset Value Question',
          },
     }
];